import { put, call, takeEvery } from 'redux-saga/effects';
import { getUserProfileGroupsList } from '../../../requests/user_profile_groups_requests/get_groups_list';
import { USER_PROFILE_GROUPS_READ_REQUEST } from '../../constants/user_profile_groups.constants';
import { userProfileGroupsReadSuccess, userProfileGroupsReadFailure } from '../../actions/user_profile_groups_actions/user_profile_groups_read.actions';

function* userProfileGroupsReadRequest({ params }) {
    const { result, error, options } = yield call(getUserProfileGroupsList, params);
    result
        ? yield put(userProfileGroupsReadSuccess(options))
        : yield put(userProfileGroupsReadFailure(error));
}

export default function* userProfileGroupsReadSaga() {
    yield takeEvery(USER_PROFILE_GROUPS_READ_REQUEST, userProfileGroupsReadRequest);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/sagas/user_profile_groups_sagas/user_profile_groups_read.saga.js